// extracted by mini-css-extract-plugin
export default {"item":"PotItem_item__RYqCC","photo":"PotItem_photo__fVT8e","info":"PotItem_info__MQqHi","name":"PotItem_name__QaRvn","desc":"PotItem_desc__ATAc-"};